import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const Technologie = () => {
  const sectorData = {
    title: "Technologie",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Les entreprises technologiques (objets connectés, IA, robotique) doivent expliquer leur innovation tout en valorisant leurs cas d'usages concrets. Associer contenu technique, évangélisation et segmentation par industrie est essentiel pour générer des leads B2B engagés.",
    name: "Technologie",
    titleContext: "au secteur des technologies",
    responseContext: "du secteur des technologies",
    expertContext: "du secteur des technologies"
  };

  return <SectorPage sector={sectorData} />;
};

export default Technologie; 